// DEV API BASE URL
// var baseUrl = "https://guinaw-warc.withvolkeno.com";


// PROD API BASE URL
var baseUrl = "https://www.back.warcfulbright.org";

export default baseUrl;
